module.exports = __webpack_public_path__ + "img/banner-roma-napoli.e04380df.jpg";